module.exports = __webpack_public_path__ + "statics/img/cate5-2@2x.cd332a8f.png";